import { alertService, createStorePersist, RequestStatus } from "common-frontend-components";
import { productsStore } from "./productsStore";
import { getStorageCall } from "@yehonadav/safestorage";
import { postsStore } from "../posts/postsStore";
import { useEffect } from "react";
import { callGetProductPostAssociationsAsync } from "../../apis/productPostAssociations";
const persistOptions = {
    name: `ramibarilan/productPostAssociations/store`,
    whitelist: ["productPostAssociationList"],
    getStorage: getStorageCall,
};
const { useStore, fetchStore, set, get } = createStorePersist({
    persistOptions,
    persistAfterClearingStorage: false,
    getDefaultValues: () => ({
        productPostAssociations: {},
        productPostAssociationList: [],
        postAssociations: {},
        productAssociations: {},
        associationsByProductId: {},
        associationsByPostId: {},
        requestStatus: RequestStatus.pending,
    })
});
const getProductPostAssociations = () => get().productPostAssociationList;
const setProductPostAssociations = (productPostAssociationList) => {
    const productPostAssociations = {};
    const postAssociations = {};
    const productAssociations = {};
    const associationsByProductId = {};
    const associationsByPostId = {};
    productPostAssociationList.forEach(productPostAssociation => {
        productPostAssociations[productPostAssociation.id] = productPostAssociation;
        if (!postAssociations[productPostAssociation.postId])
            postAssociations[productPostAssociation.postId] = [productPostAssociation.productId];
        else
            postAssociations[productPostAssociation.postId].push(productPostAssociation.productId);
        if (!productAssociations[productPostAssociation.productId])
            productAssociations[productPostAssociation.productId] = [productPostAssociation.postId];
        else
            productAssociations[productPostAssociation.productId].push(productPostAssociation.postId);
        if (!associationsByProductId[productPostAssociation.productId])
            associationsByProductId[productPostAssociation.productId] = [productPostAssociation];
        else
            associationsByProductId[productPostAssociation.productId].push(productPostAssociation);
        if (!associationsByPostId[productPostAssociation.postId])
            associationsByPostId[productPostAssociation.postId] = [productPostAssociation];
        else
            associationsByPostId[productPostAssociation.postId].push(productPostAssociation);
    });
    set({
        productPostAssociations,
        productPostAssociationList,
        postAssociations,
        productAssociations,
        associationsByProductId,
        associationsByPostId,
    });
};
// set productPostAssociations from storage
setProductPostAssociations(getProductPostAssociations());
export const productPostAssociationsStore = {
    getPostProducts: (postId) => {
        const productIds = get().postAssociations[postId];
        if (!productIds)
            return [];
        const productMap = productsStore.getProductMap();
        return productIds.filter(id => productMap[id] !== undefined).map(id => productMap[id]);
    },
    getProductPosts: (productId) => {
        const postIds = get().productAssociations[productId];
        if (!postIds)
            return [];
        const postMap = postsStore.getPostMap();
        return postIds.filter(id => postMap[id] !== undefined).map(id => postMap[id]);
    },
    getProductPostAssociations,
    getAssociationsByProductId: (productId) => get().associationsByProductId[productId] || [],
    getAssociationsByPostId: (postId) => get().associationsByPostId[postId] || [],
    setProductPostAssociations,
    useProductPostAssociations: () => useStore(fetchStore.productPostAssociationList),
    getRequestStatus: () => get().requestStatus,
    // tslint:disable-next-line:no-shadowed-variable
    setRequestStatus: (requestStatus) => { console.log({ requestStatus }); const s = get(); s.requestStatus = requestStatus; set({ requestStatus }); },
    useRequestStatus: () => useStore(fetchStore.requestStatus),
    useLoad: () => {
        const status = productPostAssociationsStore.useRequestStatus();
        const data = productPostAssociationsStore.useProductPostAssociations();
        useEffect(() => {
            if (get().requestStatus !== RequestStatus.pending)
                return;
            productPostAssociationsStore.setRequestStatus(RequestStatus.loading);
            callGetProductPostAssociationsAsync()
                .then((items) => {
                productPostAssociationsStore.setProductPostAssociations(items);
                productPostAssociationsStore.setRequestStatus(RequestStatus.loaded);
            })
                .catch((e) => {
                alertService.error(e);
                productPostAssociationsStore.setRequestStatus(RequestStatus.failed);
            });
        }, [status]);
        return { status, data };
    },
};
//# sourceMappingURL=productPostAssociationsStore.js.map